import $ from 'jquery';
import '../sass/ucg-notification.scss';

$('.close-bar').on('click', function () {
	$(this).parent().slideUp().removeClass('active');
	$('#pull-tab').slideDown().addClass('active');
});
